import { useNavigate } from "react-router-dom";
import { ArrowRight, HardHat } from "lucide-react";
import { CompanyLogo, LogoUploadButton, useCompanies } from "@/components/CompanySwitcher";

const HERO = "https://images.unsplash.com/photo-1709934645644-f055bb2b75de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Landing() {
  const { list, reload } = useCompanies();
  const navigate = useNavigate();
  const enter = (id) => {
    localStorage.setItem("company", id);
    sessionStorage.setItem("entered", "1");
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] bg-slate-950 text-slate-100" data-testid="landing-page">
      <section className="relative hidden lg:block overflow-hidden">
        <img src={HERO} alt="Şantiye vinçleri" className="absolute inset-0 w-full h-full object-cover landing-zoom" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-slate-950/20" />
        <div className="absolute bottom-0 left-0 p-14 max-w-xl landing-rise">
          <div className="text-amber-400 text-xs font-semibold tracking-[0.3em] mb-4">GRUP ŞİRKETLERİ</div>
          <p className="text-slate-300 text-base leading-relaxed">Projeler, hakedişler, puantaj ve şantiye günlükleri — her şirket için ayrı, tek platformda.</p>
        </div>
      </section>

      <section className="min-w-0 flex flex-col justify-center px-8 sm:px-16 py-16">
        <div className="flex items-center gap-3 mb-12 landing-rise">
          <div className="w-11 h-11 rounded-lg bg-amber-500 flex items-center justify-center"><HardHat className="w-6 h-6 text-slate-950" /></div>
          <span className="text-xs tracking-[0.25em] text-slate-400 font-semibold">ŞANTİYE YÖNETİMİ</span>
        </div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-4 landing-rise" data-testid="landing-title">
          YAPI YÖNETİM<br /><span className="text-amber-400">PLATFORMU</span>
        </h1>
        <p className="text-slate-400 text-sm md:text-base mb-12 landing-rise">Devam etmek için şirketinizi seçin.</p>

        <div className="space-y-4 max-w-lg">
          {list.map((c, i) => (
            <CompanyCard key={c.id} company={c} delay={150 + i * 120} onClick={() => enter(c.id)} onLogo={reload} />
          ))}
        </div>
      </section>
    </div>
  );
}

function CompanyCard({ company, delay, onClick, onLogo }) {
  return (
    <div
      style={{ animationDelay: `${delay}ms` }}
      className="landing-rise group relative rounded-2xl border border-slate-800 bg-slate-900/60 backdrop-blur hover:border-amber-500/70 hover:bg-slate-900 transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5"
      data-testid={`landing-card-${company.id}`}
    >
      <button onClick={onClick} className="w-full flex items-center gap-5 p-5 pb-9 text-left" data-testid={`landing-company-${company.id}`}>
        <CompanyLogo company={company} className="w-20 h-20 text-lg" testid={`landing-logo-${company.id}`} />
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-base sm:text-lg leading-snug">{company.name}</div>
          <div className="text-xs text-slate-400 mt-0.5">Sisteme giriş</div>
        </div>
        <ArrowRight className="w-5 h-5 text-slate-500 group-hover:text-amber-400 group-hover:translate-x-1 transition-transform duration-300" />
      </button>
      <LogoUploadButton companyId={company.id} onDone={onLogo} label={company.logo_url ? "Logo değiştir" : "Logo yükle"} className="absolute left-5 bottom-3 text-slate-300 hover:text-amber-400" />
    </div>
  );
}
